import api from '@/api'

const store = {
  state: {
    dataStoreGeofence: [],
    pagingStoreGeofence: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingStoreGeofence: {
      byField: '',
      isDesc: false
    },
    filteringStoreGeofence: {
      outletCode: null,
      type: null,
      sequence: null,
      latitude: null,
      longitude: null
    }
  },

  mutations: {
    SET_STOREGEOFENCE: (state, payload) => {
      state.dataStoreGeofence = payload
    },
    SET_PAGING_PAGE_STOREGEOFENCE: (state, payload) => {
      state.pagingStoreGeofence.page = payload
    },
    SET_PAGING_TOTAL_STOREGEOFENCE: (state, payload) => {
      state.pagingStoreGeofence.total = payload
    },
    SET_SORTING_STOREGEOFENCE: (state, payload) => {
      state.sortingStoreGeofence = payload
    },
    SET_FILTERING_STOREGEOFENCE: (state, payload) => {
      state.filteringStoreGeofence = payload
    }
  },

  getters: {
    SortingStoreGeofence: state => state.sortingStoreGeofence,
    FilteringStoreGeofence: state => state.filteringStoreGeofence,
    PagingStoreGeofence: state => state.pagingStoreGeofence,
    GetAllStoreGeofence: state => state.dataStoreGeofence,
    GetOneStoreGeofence: state => id =>
      state.dataStoreGeofence.find(
        dataStoreGeofence => dataStoreGeofence.id === id
      )
  },

  actions: {
    async UpdateSortingStoreGeofence({ commit, dispatch }, payload) {
      commit('SET_SORTING_STOREGEOFENCE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllStoreGeofence')
    },

    async UpdateFilteringStoreGeofence({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_STOREGEOFENCE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_STOREGEOFENCE', 1)
      dispatch('GetAllStoreGeofence')
    },

    async GetAllStoreGeofence({ commit, state }) {
      try {
        const result = await api.GetAllStoreGeofence(
          state.pagingStoreGeofence,
          state.sortingStoreGeofence,
          state.filteringStoreGeofence
        )
        commit('SET_PAGING_TOTAL_STOREGEOFENCE', result.headers['data-length'])
        commit('SET_STOREGEOFENCE', result.data.data)
        return result.data
      } catch (e) {
        throw e
      }
    },

    async CreateStoreGeofence({ dispatch }, payload) {
      try {
        const { data } = await api.CreateStoreGeofence(payload)
        dispatch('GetAllStoreGeofence')
        return data
      } catch (e) {
        throw e
      }
    },

    async UpdateStoreGeofence({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateStoreGeofence(payload.id, payload)
        dispatch('GetAllStoreGeofence')
        return data
      } catch (e) {
        throw e
      }
    },

    async DeleteStoreGeofence({ dispatch }, id) {
      try {
        const { data } = await api.DeleteStoreGeofence(id)
        dispatch('GetAllStoreGeofence')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
